import React from "react"
// import ContribuinteTable from "./ContribuinteTable";
import TextField from "@material-ui/core/TextField"
import { Link, withRouter } from "react-router-dom"
import { withStyles, Paper } from "@material-ui/core"
import logradouroStyle from "../../../assets/css/layout/logradouroStyle"
import Button from "../../../components/CustomButtons/Button"
import Card from "../../../components/Card/Card"
import { showNotification } from "../../../util/Constants"
import CardHeader from "../../../components/Card/CardHeader"
import CardBody from "../../../components/Card/CardBody"
import AddIcon from "@material-ui/icons/Add"
import Grid from "@material-ui/core/Grid"
import Table from "../../../components/Table/Table"
import Edit from "@material-ui/icons/Edit"
import { get } from "../../../util/motivoiptu"
import LoadingContent from "../../../components/LoadingContent"

class MotivosIptu extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      value: "",
      error: "",
      errors: {},
      nome: "",
      motivos: [],
      field: 0,
      modal: false,
      id: 0,
      motivoFiltered: [],
      search: false
    }

    this.getData = this.getData.bind(this)
    this.handlePageClick = this.handlePageClick.bind(this)
    this.handleEdit = this.handleEdit.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.toggleLoading = this.toggleLoading.bind(this)
  }

  componentWillMount() {
    this.getData()
  }

  handlePageClick(data) {
    //this.getData(data.selected + 1);
  }
  toggleLoading() {
    this.setState(state => ({
      isLoading: !state.isLoading
    }))
  }
  handleChange(event) {
    let name = event.target.name
    let errors = this.state.errors
    errors[name] = undefined
    this.setState({
      [name]: event.target.value,
      errors: errors
    })
  }

  getData(page) {
    if (!page) {
      this.toggleLoading()
    }
    get(page, (error, data) => {
      if (!page) {
        this.toggleLoading()
      }
      if (error) {
        showNotification(
          "top",
          "center",
          "Ocorreram erros, verifique o formulário e tente novamente",
          "danger"
        )
      } else {
        this.setState({
          motivos: data,
          motivoFiltered: data
        })
      }
    })
  }

  searchFilter(value) {
    let filtered = this.state.motivos
    if (value !== "") {
      this.setState({
        search: true
      })
    } else {
      this.setState({
        search: false
      })
    }
    filtered = filtered.filter((filter) => {
      if (filter.descricao !== null) {
        return filter.descricao.indexOf(value.toUpperCase()) !== -1
      } else {
        return null
      }
    })
    this.setState({ motivoFiltered: filtered })
  }

  handleEdit(key) {
    this.props.history.push("/motivos/edit/" + this.state.motivos[key].id)
  }

  render() {
    const { classes } = this.props
    return (
      <div className={classes.container}>
        <Card>
          <CardHeader color="primary">
            <Grid container direction="row">
              <Grid item lg={10} xs={12}>
                <h2 className={classes.cardTitleWhite}>Motivos de Isenção de IPTU</h2>
              </Grid>
              <Grid item lg={2} xs={12}>
                <Link to="/motivos/create" style={{ textDecoration: "none" }}>
                  <Button block color="success" round>
                    <AddIcon /> Adicionar
                  </Button>
                </Link>
              </Grid>
            </Grid>
          </CardHeader>
          <CardBody>
            <form noValidate autoComplete="off">
              <TextField
                id="standard-search"
                label="Pesquisar"
                fullWidth
                type="search"
                name="search"
                onChange={(event) => this.searchFilter(event.target.value)}
                className={classes.textField}
                margin="normal"
              />
            </form>
            <LoadingContent isLoading={this.state.isLoading}>
              <Paper className={classes.tableWrapper}>
                <Table
                  tableHeaderColor="primary"
                  actions={[
                    {
                      title: "Editar",
                      icon: (
                        <Edit
                          className={
                            classes.tableActionButtonIcon + " " + classes.edit
                          }
                        />
                      ),
                      onClick: this.handleEdit
                    }
                  ]}
                  tableHead={["#", "Descrição"]}
                  tableData={(this.state.search ? this.state.motivoFiltered : this.state.motivos).map((item, key) => {
                    return [item.id + "", item.descricao, key]
                  })}
                />
              </Paper>
            </LoadingContent>
          </CardBody>
        </Card>
      </div>
    )
  }
}
MotivosIptu = withRouter(MotivosIptu)
export default withStyles(logradouroStyle)(MotivosIptu)
